export interface NotFoundProps {}

export const useNotFound = (props: NotFoundProps) => {
  return {
    ...props,
  }
}
